/** Samasta compound `type` enum (backend). */
export const SAMASTA_TYPE = [
  'keval',
  'aavyayiyabhava',
  'karmadharaya',
  'duvigu',
  'bahuvrihi',
  'dwanda',
] as const;
